<template>
    <div class="steps">
        <template v-if="stepsStore.activeStep">
            <step :step="stepsStore.activeStep" />
        </template>
        <template v-else>
            <div>No step could be displayed...</div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { useStepsStore } from '@/widgets/Wizard/stores/steps';
import step from '@/widgets/Wizard/components/step.vue';

const stepsStore = useStepsStore();
</script>
